export const GET_DUGOUT_ORGANIZATIONS_QUERY_KEY = 'getDugoutOrganizations';

export const GET_DUGOUT_ORGANIZATION_QUERY_KEY = 'getDugoutOrganization';

export const GET_ORGANIZATION_DELETION_BLOCKERS_QUERY_KEY = 'getOrganizationDeletionBlockers';

export const ORGANIZATIONS_PATH = '/organizations';
